
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { OnboardingData } from '../OnboardingFlow';

interface FirstNameStepProps {
  data: OnboardingData;
  updateData: (data: Partial<OnboardingData>) => void;
  onNext: () => void;
}

const FirstNameStep = ({ data, updateData, onNext }: FirstNameStepProps) => {
  const [firstName, setFirstName] = useState(data.firstName);

  const handleNext = () => {
    if (firstName.trim()) {
      updateData({ firstName: firstName.trim() });
      onNext();
    }
  };

  return (
    <div className="text-center space-y-8">
      <h2 className="text-2xl font-semibold text-slate-dark font-sans">
        What's your first name?
      </h2>
      
      <div className="space-y-6">
        <Input
          type="text"
          placeholder="Enter your first name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          className="h-14 text-lg rounded-xl border-2 border-slate-soft focus:border-blue-primary transition-colors text-center font-sans"
          autoFocus
          onKeyPress={(e) => e.key === 'Enter' && handleNext()}
        />
        
        <Button
          onClick={handleNext}
          disabled={!firstName.trim()}
          className="w-full h-14 text-lg font-semibold bg-blue-primary hover:bg-blue-light disabled:bg-slate-soft disabled:cursor-not-allowed text-white rounded-xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98]"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default FirstNameStep;
